var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSelfCustody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 112,
    viewBox: "0 0 80 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.8552 43.0991V33.3707C72.8552 21.631 66.5923 10.784 56.4268 4.91523C46.2609 -0.954815 33.7355 -0.954815 23.5713 4.91523C13.4054 10.784 7.14286 21.6307 7.14286 33.3707V43.0991C2.64163 46.6132 0.0075102 52.0022 0 57.7126V93.4285C0 98.3546 1.95663 103.078 5.44 106.561C8.92212 110.043 13.6454 112 18.5714 112H61.4286C66.3546 112 71.0779 110.043 74.56 106.561C78.0434 103.078 80 98.3546 80 93.4285V57.7126C79.9923 52.0022 77.3584 46.6132 72.8571 43.0991H72.8552ZM15.7123 33.3707C15.7123 24.6935 20.3412 16.6769 27.8553 12.3376C35.3695 7.99963 44.6269 7.99963 52.1411 12.3376C59.6552 16.6769 64.2841 24.6935 64.2841 33.3707V39.3848C63.3389 39.2304 62.3836 39.1488 61.4269 39.1412H18.5698C17.6132 39.1488 16.6578 39.2304 15.7127 39.3848L15.7123 33.3707ZM71.425 93.3707C71.425 96.0225 70.3714 98.5658 68.4964 100.441C66.6201 102.317 64.0768 103.371 61.425 103.371H18.5679C15.9161 103.371 13.3728 102.317 11.4966 100.441C9.62155 98.5658 8.56797 96.0225 8.56797 93.3707V57.6548C8.56797 55.0018 9.62155 52.4584 11.4966 50.5835C13.3728 48.7085 15.9161 47.6549 18.5679 47.6549H61.425C64.0768 47.6549 66.6201 48.7085 68.4964 50.5835C70.3714 52.4585 71.425 55.0018 71.425 57.6548V93.3707Z",
    fill: "#3761F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2707 62.5864L35.4135 79.4576L27.7273 71.7714C26.0386 70.1987 23.4073 70.2446 21.7757 71.8773C20.143 73.5087 20.0971 76.1401 21.6698 77.8289L32.3839 88.5431C34.0574 90.214 36.7679 90.214 38.4414 88.5431L58.3418 68.6427C59.9145 66.9551 59.8686 64.3227 58.2359 62.691C56.6046 61.0583 53.9731 61.0124 52.2843 62.5864L52.2707 62.5864Z",
    fill: "#00CD98"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfCustody);
export default __webpack_public_path__ + "static/media/self-custody.d0468d79f2d297895ccc63566a569627.svg";
export { ForwardRef as ReactComponent };